import request from '@/utils/request'

// 管理员登录
export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

// 刷新token
export function refreshToken() {
  return request({
    url: '/admin/refreshToken',
    method: 'put'
  })
}

// 获取当前管理员信息
export function getCurrentAdmin() {
  return request({
    url: '/admin/current',
    method: 'get'
  })
}

// 获取管理员列表
export function getAdminList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params
  })
}

// 创建管理员
export function createAdmin(data) {
  return request({
    url: '/admin',
    method: 'post',
    data
  })
}

// 更新管理员
export function updateAdmin(data) {
  return request({
    url: '/admin',
    method: 'put',
    data
  })
}

// 删除管理员
export function deleteAdmin(adminId) {
  return request({
    url: `/admin/${adminId}`,
    method: 'delete'
  })
}

// 获取管理员详情
export function getAdminById(adminId) {
  return request({
    url: `/admin/${adminId}`,
    method: 'get'
  })
}

// 启用/禁用管理员
export function changeAdminStatus(adminId, status) {
  return request({
    url: `/admin/${adminId}/status`,
    method: 'put',
    params: { status }
  })
}

// 重置管理员密码
export function resetAdminPassword(adminId, newPassword) {
  return request({
    url: `/admin/${adminId}/password`,
    method: 'put',
    params: { newPassword }
  })
}

// 获取管理员操作日志
export function getAdminOperationLogs(adminId, params) {
  return request({
    url: `/admin/${adminId}/logs`,
    method: 'get',
    params
  })
}

